import SliderIndex from "./component-slider";
import ContentIndex1 from "./component-content";
import { useHeaderHome } from "../../../hooks/apis/headers";

function Section1_index() {
  const { data, isLoading, isError } = useHeaderHome();

  if (isLoading)
    return (
      <div
        className={
          isLoading ? "active loading position-fixed" : "loading position-fixed"
        }
      >
        <img src="/images/loading.svg" className="img-fluid" alt="loading" />
      </div>
    );
  if (isError) return <h3>Error</h3>;

  return (
    <div id="section1">
      <SliderIndex />
      <ContentIndex1 data={data} />
    </div>
  );
}

export default Section1_index;
